import { ace_index } from '@axo/shared/data-access/types';
import { ace_index_hooks } from '@axo/shared/data-access/hooks';
import {
  FilterAppliedIndicator,
  SearchFilterCard,
} from '../../../components/SearchFilterCard';
import { usePersistedState } from '../../../hooks/utils/usePersistedState';
import { ColumnID, SearchResults } from '../../../components/SearchResults';

interface Props {
  marketCountry: string;
}

export function CustomFilterTab({ marketCountry }: Props) {
  const [columns, setColumns] = usePersistedState(
    'ace.customfilter.columns.v1',
    defaultColumns,
    window.localStorage
  );

  const [rawQuery, setQuery] = usePersistedState(
    'ace.customfilter.query.v1',
    defaultQuery,
    window.sessionStorage
  );

  const query: ace_index.FindInput = {
    ...rawQuery,
    LoanApplicationMarketCountry: marketCountry,
  };

  const active = !ace_index_hooks.useACEIndexQuery(query).isIdle;

  return (
    <div>
      <SearchFilterCard
        editable
        query={query}
        setQuery={setQuery}
        clearQuery={() => setQuery(defaultQuery)}
        marketCountry={marketCountry}
        cardProps={{
          id: 'CustomFilter',
          title: 'Filters',
          leftTag: active && <FilterAppliedIndicator text="Filter applied" />,
        }}
      />

      <SearchResults
        query={query}
        setQuery={setQuery}
        columns={columns}
        setColumns={setColumns}
        sortable
      />
    </div>
  );
}

const defaultColumns: ColumnID[] = [
  'HumanReadableID',
  'CompletedAt',
  'Status',
  'AppliedAmount',
  'FirstName',
  'LastName',
  'UpdatedAt',
  'Owner',
  'LockedBy',
];

const defaultQuery: ace_index.FindInput = {};
